var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#9083E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.834 22.95c-6.39 0-10.034-4.467-10.186-11.9h3.2c.106 5.456 2.465 7.767 4.334 8.243V11.05h3.014v4.705c1.845-.202 3.784-2.346 4.438-4.705h3.014a9.17 9.17 0 0 1-1.444 3.402 8.973 8.973 0 0 1-2.656 2.53 9.26 9.26 0 0 1 3.028 2.459 9.479 9.479 0 0 1 1.772 3.509h-3.317a5.9 5.9 0 0 0-1.788-2.87 5.717 5.717 0 0 0-3.047-1.382v4.252h-.362Z",
    fill: "#fff"
  })));
};
export default SvgVk;